/* eslint-disable no-throw-literal */
import { httpPost } from "./HttpService";
import { API_RETRIEVE_DEMAND_RATES } from "../config";

// Service call used in Interest Rate Section of Homepage

export const retrieveDemandRates = async (payload: object) => {
  try {
    const response = await httpPost(API_RETRIEVE_DEMAND_RATES, payload);
    const demandRates = response?.data?.demandRates || [];
    if (demandRates?.length > 0) {
      // const rate = `${demandRates[0]?.rate.toFixed(2)}%<sup>*</sup>`;
      const rate = `${demandRates[0]?.rate.toFixed(2)}`;
      return rate?.toString();
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

